var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 5,
    viewBox: "0 0 8 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.34731 4.44784L7.85629 0.869962C8.0479 0.661662 8.0479 0.343084 7.85629 0.147036C7.66467 -0.049012 7.34132 -0.049012 7.1497 0.147036L4 3.36957L0.850299 0.147036C0.646707 -0.049012 0.335329 -0.049012 0.143713 0.147036C-0.0479042 0.343084 -0.0479042 0.661662 0.143713 0.869962L3.64072 4.44784C3.84431 4.64388 4.15569 4.64388 4.34731 4.44784Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron_down.94693a29fb51160f733abc36a8357e2c.svg";
export { ForwardRef as ReactComponent };